import { useEffect } from 'react';

import useStepStore, { type Step } from '@/stores/steps';

export type UseContentRenderIdentifierOptions = {
  content: Step['content'];
  onGoBackRender?: () => void;
};

export const useContentRenderIdentifier = ({ content, onGoBackRender }: UseContentRenderIdentifierOptions) => {
  const contentHistory = useStepStore(state => state.contentHistory);

  useEffect(() => {
    const lastContent = contentHistory[contentHistory.length - 1];

    if (lastContent?.content !== content) {
      return;
    }

    const [latestContentRendered] = contentHistory
      .filter(item => item.content === content)
      .sort((a, b) => new Date(b.renderedAt).getTime() - new Date(a.renderedAt).getTime());

    if (!latestContentRendered) {
      return;
    }

    if (latestContentRendered.origin === 'previous' && onGoBackRender) {
      onGoBackRender();
    }
  }, [content, onGoBackRender, contentHistory]);
};
